/* @flow */
import React from 'react';
import Container from 'components/Container.jsx';
import cx from 'classnames';

import './styles/CenteredContainer.scss';

class CenteredContainer extends React.Component {
  render() {
    return (
      <div className={cx('CenteredContainer', this.props.className)}>
        <div className="CenteredContainer-wrap">
          <Container {...this.props}>
            {this.props.children}
          </Container>
        </div>
      </div>
    );
  }
}

export default CenteredContainer;



// WEBPACK FOOTER //
// ./src/components/CenteredContainer.jsx